import NPK from "./npk";
export default NPK;